import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import Dropdown from './dropdown_table';
import InputFilter from '../input/input-filter/input-filter';

@mixin.decorate(window.CssClassMixin)

export default class TableHeader extends React.Component {
	static propTypes = {
		name: PropTypes.string,
		label: PropTypes.string,
		format: PropTypes.oneOf(['text', 'currency', 'number', 'percentage', 'boolean', 'date', 'datetime', 'time']),
		sortable: PropTypes.bool,
		sortDirection: PropTypes.string,
		sortFieldName: PropTypes.string,
		onSort: PropTypes.func,
		filterClientSideTable: PropTypes.func
	};

	static defaultProps = {
		themeClassKey: 'table.header',
		sortable: true,
		sortDirection: null,
		sortFieldName: null,
		onSort: function(sortData) { return true; },
		filterClientSideTable: () => {}
	};

	state = {
		dropdownIsVisible: false
	}

	headerClassName() {
		var className = this.className();

		if(!!this.props.format) {
			className += ' table-header--' + this.props.format;
		}

		return className;
	}

	getLabel() {
		return this.props.label;
	}

	labelClassName() {
		var className = '';

		if(!this.props.clearTheme) {
			className += Realize.themes.getCssClass('table.header.label');
		}

		if(this.props.sortable) {
			className += " sortable";

			var sortDirection = this.props.sortDirection;

			if(sortDirection !== null) {
				className += " " + sortDirection;
			}
		}

		return className;
	}

	sortColumn() {
		if(this) {
			if(!this.props.sortable) {
				return null;
			}

			var sortData = this.buildSortData();
			this.props.onSort(sortData);
		}
	}

	buildSortData() {
		var sortField = this.getSortFieldName();
		var sortDirection = this.getSortDirection();

		return {
			field: sortField,
			direction: sortDirection
		};
	}

	getSortFieldName() {
		return this.props.sortFieldName || this.props.name;
	}

	getSortDirection() {
		var currentSortDirection = this.props.sortDirection;

		if(currentSortDirection === null || currentSortDirection == 'desc') {
			return 'asc';
		} else if(currentSortDirection == 'asc') {
			return 'desc';
		}
	}

	renderInputFilter() {
		const field = this.props.fields.length > 0 ? this.props.fields.find(item => item.name === this.props.name) : this.props.fields;

		return(
			<InputFilter
				field={field}
				filterClientSideTable={this.props.filterClientSideTable}
				name={this.props.name}
			/>
		)
	}

	renderDropdown() {
		const { onSortTable, name, format } = this.props
		return (
			<Dropdown
			  sortTable={onSortTable}
			  nameColumn={name}
			  formatColumn={format}
			  closeDropdownAfterOrdering={this.closeDropdown.bind(this)}
			/>
		)
	}

	/**
	 * @description Mostra o dropdown caso esteja oculto ou oculta caso esteja aberto
	 */
	showDropdown() {
		this.setState(prevState => ({
			dropdownIsVisible: !prevState.dropdownIsVisible
		}))
	}
	/**
	 * @description Fecha o dropdown
	 */
	closeDropdown() {
		this.setState({dropdownIsVisible: false})
	}

	render() {
		const { dropdownIsVisible } = this.state
		if(this.props.className === 'column-fixed-actions')
			return (
				<>
					<th className='table-header'  tabIndex="-1" style={{width: '80px'}}>
						<span style={{minWidth: '70px', display: 'block'}} tabIndex="-1"></span>
					</th>
					<th className={this.headerClassName()} tabIndex="0" aria-label={this.getLabel()} style={{position: 'absolute', right: '12px'}}>
						<span className={this.labelClassName()} style={{ width: '78px', right: '-1px', minWidth: '70px'}}>
							{this.getLabel()}
						</span>
					</th>
				</>
			);

		if(this.props.className !== 'column-fixed-actions')
			return (
				<th
					className={this.headerClassName()}
					tabIndex="0"
					aria-label={this.getLabel()}
					// onBlur={this.closeDropdown.bind(this)}
				>
					<span
						// onClick={this.showDropdown.bind(this)}
						className={this.labelClassName()}
					>
						{this.getLabel()}
						{/* <i className="tiny material-icons">arrow_drop_down</i> */}
					</span>

					{/* { dropdownIsVisible ? this.renderDropdown() : null } */}

					{/* { !this.props.isMobile ? this.renderInputFilter() : null } */}
				</th>
			);
	}
}
